<template>
  <h3
    :class="[
      'recommendation__name',
      {
        'recommendation__name--colors': colorOptionsLength,
      },
    ]"
    itemprop="name"
    :title="name"
  >
    {{ name }}
  </h3>
</template>

<script>
export default {
  name: 'RecommendationName',
  props: {
    name: {
      type: String,
      required: true,
    },
    colorOptionsLength: {
      type: Number,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.recommendation__name {
  user-select: none;
}
</style>
